var exports = {
  "y": "x112a1f60--66bfba--divider",
};

module.exports = exports;
